import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MainPage from "./pages/MainPage";
import TopicsPage from "./pages/TopicsPage";
import PostList from "./pages/PostList";
import Dashboard from "./pages/Dashboard";
import Login from "./components/Login";
import Register from "./components/Register";
import Layout from "./components/Layout/Layout";
import { AuthProvider } from './context/AuthContext';
import ThemeProvider from "./context/ThemeContext";
import Profile from "./pages/Profile";
import AdminPanel from "./pages/Admin/AdminPanel";
import ModeratorPanel from "./pages/Admin/ModeratorPanel";
import DebugPage from "./pages/DebugPage";
import AgeVerification from "./components/AgeVerification/AgeVerification";

import Post from "./components/Post/Post"; // 引入 Post 組件


const App = () => {
    const [isAgeVerified, setIsAgeVerified] = useState(false);

    const handleAgeVerified = () => {
        setIsAgeVerified(true);
    };

    return (
        <AuthProvider>
            <ThemeProvider>
                <AgeVerification onVerified={handleAgeVerified} />
                {isAgeVerified && (
                    <Router basename="/">
                        <Layout>
                            <Routes>
                                {/* 靜態路由 - 必須在動態路由之前 */}
                                <Route path="/" element={<MainPage />} />
                                <Route path="/topics" element={<TopicsPage />} />
                                <Route path="/topics/:topicId" element={<PostList />} />
                                <Route path="/posts/:uuid" element={<Post />} /> {/* 指向 Post 組件 (使用 UUID) */}
                                <Route path="/dashboard" element={<Dashboard />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/debug" element={<DebugPage />} />

                                {/* 管理員和版主路由 - 特定路由 */}
                                <Route path="/system/admin" element={<AdminPanel />} />
                                <Route path="/system/moderate" element={<ModeratorPanel />} />

                                {/* 動態路由 - 必須在最後 */}
                                <Route path="/user/:username" element={<Profile />} />
                            </Routes>
                        </Layout>
                    </Router>
                )}
            </ThemeProvider>
        </AuthProvider>
    );
};

export default App;
